import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setStatus("sent");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Try again.");
      setStatus("error");
    }
  }

  return (
    <div className="min-h-screen bg-[#f5f2eb] flex items-center justify-center p-6" data-testid="forgot-page">
      <div className="w-full max-w-md border border-[#0a0a0a] bg-[#ede8dc] p-8">
        <div className="bm-eyebrow text-neutral-500 mb-2">RESET · STEP 1</div>
        <h1 className="bm-headline text-3xl mb-2">Forgot password.</h1>
        <p className="bm-eyebrow text-neutral-500 mb-6">
          Enter your email and we'll send a reset link. Link expires in 60 minutes.
        </p>

        {status === "sent" ? (
          <div className="border border-[#0a0a0a]/40 bg-[#f5f2eb] p-4 mb-4 text-sm" data-testid="forgot-sent">
            If <strong>{email}</strong> is a registered account, a reset link is on its way.
            Check your inbox (and spam folder).
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <label className="bm-eyebrow text-neutral-500 block mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-[#0a0a0a] bg-transparent py-2 mb-6 focus:outline-none"
              data-testid="forgot-email"
              placeholder="you@example.com"
            />
            {error && <div className="text-sm text-[#c72c2c] mb-3" data-testid="forgot-error">{error}</div>}
            <button
              type="submit"
              disabled={status === "sending"}
              className="w-full bg-[#0a0a0a] text-[#f5f2eb] py-3 bm-eyebrow disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {status === "sending" ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <Link
          to="/login"
          className="bm-eyebrow text-neutral-500 hover:text-[#0a0a0a] block mt-6 text-center"
          data-testid="forgot-back"
        >
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
